import React, { useEffect, useState } from "react";

/* ================== ENV ================== */
const GITHUB_USERNAME = process.env.REACT_APP_GITHUB_USERNAME;
const REPO_NAME = process.env.REACT_APP_GITHUB_REPO;
const BRANCH = process.env.REACT_APP_GITHUB_BRANCH;

export default function Reviews() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        // 🚀 Use CDN for speed (no token needed)
        const url = `https://cdn.jsdelivr.net/gh/${GITHUB_USERNAME}/${REPO_NAME}@${BRANCH}/testimonials/testimonials.json`;

        const res = await fetch(url);
        const data = await res.json();

        // show only approved reviews
        const approvedReviews = (data.reviews || []).filter(
          (r) => r.approved
        );

        setReviews(approvedReviews);
      } catch (error) {
        console.error("Failed to fetch testimonials:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchReviews();
  }, []);

  if (loading) {
    return (
      <div className="py-20 text-center text-white/60">
        Loading reviews…
      </div>
    );
  }

  return (
    <section className="py-20 md:py-28">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h1 className="section-heading mb-12">All Reviews</h1>

        {reviews.length === 0 ? (
          <p className="text-white/60">No reviews yet.</p>
        ) : (
          reviews.map((r, i) => (
            <blockquote key={i} className="mb-12">
              <p className="text-white/85 text-base md:text-lg leading-relaxed max-w-3xl mx-auto">
                “{r.text}”
              </p>
              <footer className="mt-4 text-white/50 text-sm tracking-wide">
                — {r.author} · ⭐ {r.rating}/5
              </footer>
            </blockquote>
          ))
        )}
      </div>
    </section>
  );
}
